export default {
  "content": "<path d=\"M15.5 22H9v-2h6.5v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.276 1.631l-5.174 6.37h.612l7.756-4.848 1.06 1.695L17.486 8H22a1 1 0 011 1c0 5.62-5.027 10-11 10S1 14.62 1 9a1 1 0 011-1h8.523l6.2-7.63 1.553 1.261zm-15.203 8.37c.55 3.873 4.251 7 8.927 7 4.676 0 8.376-3.127 8.927-7H3.073z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};